import axios from "axios";
import { getToken } from "@/global";
import router from "@/router";
import { setarUsuarioLogado } from '@/db/usuario'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

axios.interceptors.request.use(
  (config) => {
    if (config.params == null) {
      config.params = {};
    }
    if (config.params.token == null) {
      config.params.token = getToken();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      //store.commit("usuario/setUsuarioLogado", null);
      setarUsuarioLogado(null)
      router.push("/login").catch(()=>{})

      return {
        data: {
          success: false,
          msg: "Sessão expirada. Faça login novamente",
        },
      };
    }
    return Promise.reject(error);
  }
);
